module.exports = __webpack_public_path__ + "static/img/Bachelor_010427.83fd240.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010427.jpg
// module id = 163
// module chunks = 0